import { IConflict } from '@/contracts/modules/note/entities/IConflict'
import { IVersion } from '@/contracts/modules/note/entities/IVersion'
import { IDocument } from '@/contracts/modules/note/entities/IDocument'

export class Conflict implements IConflict {
  constructor(private left: IVersion, private right: IVersion, private base: IDocument | null) {}

  getLeft(): IVersion {
    return this.left
  }

  getRight(): IVersion {
    return this.right
  }

  getBase(): IDocument | null {
    return this.base
  }
}
